import React, { useState, useEffect } from 'react';
import './index.css';

import { useWeather, getMoodClass } from './hooks/useWeather';
import { useScrollReveal } from './hooks/useScrollReveal';

import TwoPathsLanding from './components/TwoPathsLanding';
import Nav from './components/Nav';
import WeatherCorner from './components/WeatherCorner';
import Hero from './components/Hero';
import NumbersTicker from './components/NumbersTicker';
import OriginStory from './components/OriginStory';
import CareerChart from './components/CareerChart';
import Experience from './components/Experience';
import Projects from './components/Projects';
import WhatImBuilding from './components/WhatImBuilding';
import SkillConstellation from './components/SkillConstellation';
import Education from './components/Education';
import ReadingFeed from './components/ReadingFeed';
import AIChat from './components/AIChat';
import SmartContact from './components/SmartContact';
import HireMe60, { HireMeButton } from './components/HireMe60';

import Leadership from './components/Leadership';
import PersonalLayer from './components/PersonalLayer';
import ThingsIBelieve from './components/ThingsIBelieve';
import AntiResume from './components/AntiResume';
import Manifesto from './components/Manifesto';
import VisitorMemory from './components/VisitorMemory';
import EasterEggTerminal from './components/EasterEggTerminal';
import SQLEasterEgg from './components/SQLEasterEgg';
import PitchDeckOrb from './components/PitchDeckOrb';
import PhysicsMode from './components/PhysicsMode';

function WorkLayout({ path, setTourActive, setSqlOpen }) {
  return (
    <>
      <Hero path={path} />
      <div style={{ padding: '0 12%', paddingTop: '40px', paddingBottom: '40px', borderTop: '1px solid rgba(26,26,26,0.06)', display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.2em', color: 'var(--ink-light)', textTransform: 'uppercase' }}>Quick tour →</span>
        <HireMeButton onClick={() => setTourActive(true)} />
      </div>
      <NumbersTicker />
      <Experience />
      <Projects path={path} />
      <SkillConstellation />
      <Education />
      <Leadership />
      <OriginStory />
      <CareerChart />
      <ThingsIBelieve />
      <ReadingFeed />
      <AntiResume />
      <Manifesto />
      <PersonalLayer />
      <SmartContact />
    </>
  );
}

function VisionLayout({ path }) {
  return (
    <>
      <Hero path={path} />
      <NumbersTicker />
      <Projects path={path} />
      <WhatImBuilding />
      <ThingsIBelieve />
      <ReadingFeed />
      <OriginStory />
      <CareerChart />
      <Experience />
      <SkillConstellation />
      <Education />
      <Leadership />
      <AntiResume />
      <Manifesto />
      <PersonalLayer />
      <SmartContact />
    </>
  );
}

export default function App() {
  const [path, setPath] = useState(null);
  const [tourActive, setTourActive] = useState(false);
  const [sqlOpen, setSqlOpen] = useState(false);
  const weather = useWeather();
  useScrollReveal();

  useEffect(() => {
    if (!weather) return;
    const hour = parseInt(new Date().toLocaleString('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false }));
    const moodClass = getMoodClass(weather, hour);
    document.body.className = moodClass;
    return () => { document.body.className = ''; };
  }, [weather]);

  const handleChoose = (choice) => {
    setPath(choice);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <>
      {!path && <TwoPathsLanding onChoose={handleChoose} />}

      {path && (
        <div style={{ minHeight: '100vh' }} data-path={path}>
          <Nav path={path} />
          <WeatherCorner weather={weather} />
          <VisitorMemory />
          <AIChat />
          <PitchDeckOrb />
          <PhysicsMode />
          <EasterEggTerminal />
          <SQLEasterEgg open={sqlOpen} onClose={() => setSqlOpen(false)} />
          <HireMe60 active={tourActive} onClose={() => setTourActive(false)} />

          {path === 'work'
            ? <WorkLayout path={path} setTourActive={setTourActive} setSqlOpen={setSqlOpen} />
            : <VisionLayout path={path} />
          }

          <div style={{
            padding: '24px 12%',
            background: '#1a1a1a',
            borderTop: '1px solid rgba(255,255,255,0.07)',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            flexWrap: 'wrap', gap: '12px',
          }}>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.15em', color: 'rgba(250,250,248,0.2)', textTransform: 'uppercase' }}>
              Mekhal Raj Rajendran · {new Date().getFullYear()}
            </span>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.15em', color: 'rgba(250,250,248,0.12)', textTransform: 'uppercase' }}>
              Phase 3 of 3 · Try pressing /
            </span>
          </div>
        </div>
      )}
    </>
  );
}
